export const isMobile = (): boolean => {
	// 既存と同じロジック
	const userAgent = window.navigator.userAgent.toLowerCase();
	return (
		userAgent.indexOf('iphone') > -1 || userAgent.indexOf('android') > -1
	);
};



// WEBPACK FOOTER //
// ./src/utils/MobileCheck.ts